export class GlobalAdjustments {
    vatRate = 20;
    excludeUsedValuesVat = false;
    excludeFutureValuesVat = false;
    valuationReductionAmount = 0;
    usedValueAdjustment = 0;
    usedValueAdjustmentType = 0;
    futureValueAdjustment = 0 ;
    futureValueAdjustmentType = 0;
}



// WEBPACK FOOTER //
// ./src/app/settings/models/global-adjustments.model.ts